import { useEffect, useRef } from 'react';
import moment from 'moment-timezone'; // Needed for timezone config.
import HighchartsReact from 'highcharts-react-official';
import { LineChartOptions } from './Chart.types';
import { getLineChartBaseOptions } from './Chart.utils';

export const LineChart = ({
  chartOptions,
  data,
  timezone,
  shouldReflow,
  ...props
}: LineChartOptions) => {
  const options = getLineChartBaseOptions({
    data,
    chartOptions,
  });

  const chartRef = useRef<HighchartsReact>(null);

  if (timezone) {
    // Higchart uses moment to deduce timezone offset.
    // @ts-ignore
    window.moment = moment;
    options.time = {
      timezone,
    };
  }

  useEffect(() => {
    if (shouldReflow) {
      chartRef.current?.chart?.reflow();
    }
  }, [shouldReflow]);

  return (
    <div {...props}>
      <HighchartsReact
        options={options}
        ref={chartRef}
        containerProps={{ style: { width: '100%', height: '100%' } }}
      />
    </div>
  );
};
